import { assetQuery, sanityFetch } from '../services/sanity';
// ---------- FUNCTIONS ----------
export const deriveNationMap = (nations) => {
    if (!nations) {
        return new Map();
    }
    const nationMap = new Map();
    nations.forEach((nation) => {
        if (!nation.name) {
            return;
        }
        nationMap.set(nation.abbreviatedName || nation.name, nation);
    });
    return nationMap;
};
export const getNations = async (config) => {
    const results = await sanityFetch(config, `*[
    _type == "nation"
    && !(_id in path("drafts.**"))
  ] ${nationQuery}`);
    return results;
};
// ---------- QUERIES ----------
export const nationQuery = `{
  _id,
  name,
  abbreviatedName,
  slug,
  flag ${assetQuery}
}`;
//# sourceMappingURL=nations.js.map